import { render, staticRenderFns } from "./MarketingText.vue?vue&type=template&id=2552ec10"
import script from "./MarketingText.vue?vue&type=script&lang=js"
export * from "./MarketingText.vue?vue&type=script&lang=js"
import style0 from "./MarketingText.vue?vue&type=style&index=0&id=2552ec10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports